import styles from "../TalentProfile.module.css";

export default function Card({ icon: Icon, title, subtitle, children }) {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon}>
            <Icon size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>{title}</div>
            {subtitle && <div className={styles.cardSubtitle}>{subtitle}</div>}
          </div>
        </div>
      </div>
      <div className={styles.cardBody}>{children}</div>
    </div>
  );
}
